import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.less'
import '@/assets/styles/element-#2855F1/index.css'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import formCreate from '@form-create/element-ui'
import query from '@/utils/query'
import { request } from '@/utils/request'

// svg组件
// import SvgIcon from '@/components/SvgIcon'

// add mockjs
// import '@/mock'

Vue.use(ElementUI)
Vue.use(formCreate)
// 1. 全局注册SvgIcon组件
// Vue.component('SvgIcon', SvgIcon)
// 2. 载入所有svg icon
// const requireContext = require.context('./assets/svgs', false, /\.svg$/)
// requireContext.keys().forEach(requireContext)

Vue.prototype.$query = query // 请求参数
Vue.prototype.$http = request

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
